import React from 'react';
import { Form } from 'react-bootstrap';
const STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
export function StateSelect(_ref) {
  let {
    onChange,
    state
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "state",
    onChange: onChange,
    size: "md",
    type: "text",
    value: state
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), STATES.map(state => /*#__PURE__*/React.createElement("option", {
    key: state,
    value: state
  }, state))));
}